import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

export interface CrudTotalSchemaItem<Row = any> {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  value: (data: Row) => React.ReactNode;
  label: string;
  backgroundColor?: string;
}

export interface CrudTotalProps<Row = any> {
  schema: CrudTotalSchemaItem<Row>[];
  data: Row;
}

export function CrudTotal<Row = any>({ schema, data }: CrudTotalProps<Row>) {
  return (
    <Grid container spacing={1}>
      {schema.map((item, key) => {
        return (
          <Grid
            key={key}
            container
            size={{
              xs: item.xs,
              sm: item.sm,
              md: item.md,
              lg: item.lg,
              xl: item.xl,
            }}
          >
            <Card
              sx={{
                backgroundColor: item.backgroundColor,
                p: 2,
                width: "100%",
              }}
            >
              <Typography variant="h6" color="textPrimary">
                {item.value(data)}
              </Typography>
              <Typography variant="subtitle2" color="textSecondary">
                {item.label}
              </Typography>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}
